export const DOCUMENT_LIBRARY_ROUTE_PATH = 'document-library';
